import { breadcrumbScript } from "@/lib/seo-jsonld";
import { createFileRoute, Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";
import { useCategoryTree } from "@/lib/categories";

export const Route = createFileRoute("/kateqoriyalar")({
  component: CategoriesPage,
  head: () => ({
    meta: [
      { title: "Bütün kateqoriyalar — elanlar | Albazar.az" },
      {
        name: "description",
        content:
          "Albazar.az-da bütün kateqoriyalar: mənzil, ev, maşın, telefon, mebel, iş elanları və daha çox. Pulsuz elan yerləşdir, axtar və tap.",
      },
      { property: "og:title", content: "Bütün kateqoriyalar — elanlar | Albazar.az" },
      {
        property: "og:description",
        content:
          "Albazar.az-da bütün kateqoriyalar: mənzil, ev, maşın, telefon, mebel, iş elanları və daha çox.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://albazar.az/kateqoriyalar" },
    ],
    links: [{ rel: "canonical", href: "https://albazar.az/kateqoriyalar" }],
    scripts: [
      breadcrumbScript([{ name: "Kateqoriyalar", path: "/kateqoriyalar" }]),
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "Bütün kateqoriyalar — Albazar.az",
          url: "https://albazar.az/kateqoriyalar",
        }),
      },
    ],
  }),
});

function CategoriesPage() {
  const { main, subs } = useCategoryTree();

  return (
    <main className="mx-auto w-full max-w-5xl px-3 pb-24 pt-4 sm:px-4">
      <h1 className="text-xl font-black tracking-tight sm:text-2xl">Bütün kateqoriyalar</h1>
      <p className="mt-1 text-sm text-muted-foreground">
        Lazım olan bölməni seçin — elanları görün və ya pulsuz elan yerləşdirin.
      </p>

      <div className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
        {main.map((c) => {
          const subList = subs[c.slug] ?? [];
          return (
            <section
              key={c.slug}
              className="rounded-2xl border border-border bg-card p-3 shadow-card transition hover:shadow-md"
            >
              <Link
                to="/kateqoriya/$slug"
                params={{ slug: c.slug }}
                search={{ alt: "", marka: "" }}
                className="flex items-center gap-2.5"
              >
                <span
                  aria-hidden
                  className="grid size-10 shrink-0 place-items-center rounded-xl bg-primary/10 text-xl"
                >
                  {c.icon || "🏷"}
                </span>
                <span className="min-w-0">
                  <span className="block truncate text-sm font-bold leading-tight">{c.name}</span>
                  <span className="block text-[11px] text-muted-foreground">
                    {subList.length > 0 ? `${subList.length} alt bölmə` : "Elanlara bax"}
                  </span>
                </span>
                <ChevronRight className="ml-auto size-4 shrink-0 text-muted-foreground" />
              </Link>
              {subList.length > 0 && (
                <div className="mt-2.5 flex flex-wrap gap-1.5 border-t border-border/60 pt-2.5">
                  {subList.slice(0, 6).map((s) => (
                    <Link
                      key={s.slug}
                      to="/kateqoriya/$slug"
                      params={{ slug: c.slug }}
                      search={{ alt: s.slug, marka: "" }}
                      className="rounded-full bg-muted px-2 py-0.5 text-[11px] font-medium text-muted-foreground transition hover:bg-accent hover:text-foreground"
                    >
                      {s.name}
                    </Link>
                  ))}
                  {subList.length > 6 && (
                    <Link
                      to="/kateqoriya/$slug"
                      params={{ slug: c.slug }}
                      search={{ alt: "", marka: "" }}
                      className="rounded-full bg-muted px-2 py-0.5 text-[11px] font-semibold text-primary"
                    >
                      +{subList.length - 6} daha
                    </Link>
                  )}
                </div>
              )}
            </section>
          );
        })}
      </div>
    </main>
  );
}
